import { apiRequestWithoutCompnay } from "@/services";
import * as env from "@/config/env";

// New, additive brand system: fetches brands/<BRAND_PROFILE>.json's name
// (served by GET /api/v2/brand-profile) and applies it as the page title.
// Independent of the existing brandSettings.json / Vuex brandSettings flow —
// this does not read or write that state. The header/login logos are wired
// directly to /api/v2/brand-profile/logo/:key in the components that render
// them, so they don't need any JS wiring here.
//
// The fetch is memoized in `cachedPromise` so both the initial main.js call
// and the router's per-route title prefix (router/index.js) share one
// request and stay in sync, instead of the router falling back to the old
// brandSettings.json on every navigation.

let cachedPromise = null;

export const getBrandProfile = () => {
    if (!cachedPromise) {
        cachedPromise = apiRequestWithoutCompnay("get", env.GET_BRAND_PROFILE)
            .then((response) => {
                if (response.status !== 200 || !response.data || !response.data.data) return null;
                return response.data.data;
            })
            .catch((error) => {
                console.error(error);
                return null;
            });
    }
    return cachedPromise;
};

export const applyBrandProfile = async () => {
    const profile = await getBrandProfile();
    if (profile && profile.name) document.title = profile.name;
    return profile;
};
